import ImageAndText from 'components/display/ImageAndText'
import ImagesAndText from 'components/display/ImagesAndText'
import TextAndText from 'components/display/TextAndText'
import PageSectionMedia from 'components/display/PageSectionMedia'

export default {
  ContentfulPageSectionImageAndText: ImageAndText,
  ContentfulPageSectionImagesAndText: ImagesAndText,
  ContentfulPageSectionTextAndText: TextAndText,
  ContentfulPageSectionMedia: PageSectionMedia,
}
